<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-user-pen"></i>
    </div>
    <div>
      <h2 class="dialog-title">Edit User</h2>
      <p class="dialog-subtitle">Fill in the user details</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body" style="padding-top: 0px; min-height: 426px; height: 426px;">
  <div class="dialog-tabs">
    <div class="dialog-tab" [class.active]="activeTab === 0" (click)="activeTab = 0">
      User
    </div>
    <div class="dialog-tab" [class.active]="activeTab === 1" (click)="onRolesTabClick()">
      Roles
    </div>
  </div>

  <form [formGroup]="userForm" class="dialog-form-grid">
    @if (activeTab === 0) {
      <!-- User Name -->
      <div class="dialog-field-group">
        <mat-label class="mat-form-field-label">User Name <span class="req">*</span></mat-label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="userName" placeholder="Enter user name">
          @if( userForm.get('userName')?.hasError('required') ) {
            <mat-error>User Name is required</mat-error>
          }
          @if( userForm.get('userName')?.hasError('invalidcharacters') ) {
            <mat-error>User Name contains invalid characters</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Email -->
      <div class="dialog-field-group">
        <mat-label class="mat-form-field-label">Email <span class="req">*</span></mat-label>
        <mat-form-field appearance="outline">
          <input matInput type="email" formControlName="email" placeholder="Enter email">
          @if( userForm.get('email')?.hasError('required') ) {
            <mat-error>Email is required</mat-error>
          }
          @if( userForm.get('email')?.hasError('email') ) {
            <mat-error>Email must be valid</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Authentication Type -->
      <div class="dialog-field-group">
        <mat-label class="mat-form-field-label">Authentication Type <span class="req">*</span></mat-label>
        <mat-form-field appearance="outline">
          <mat-select formControlName="authType" placeholder="Select authentication type">
            <mat-option [value]="1">Internal</mat-option>
            <mat-option [value]="3">MyID</mat-option>
          </mat-select>
          @if( userForm.get('authType')?.hasError('required') ) {
            <mat-error>Authentication Type is required</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Password -->
      <div class="dialog-field-group">
        <mat-label class="mat-form-field-label">Password <span class="req">*</span></mat-label>
        <mat-form-field appearance="outline">
          <input matInput type="password" formControlName="password" placeholder="Enter password">
          @if( userForm.get('password')?.hasError('required') ) {
            <mat-error>Password is required</mat-error>
          }
          @if( userForm.get('password')?.hasError('minLength') ) {
            <mat-error>Password must be at least 8 characters long</mat-error>
          }
          @if( userForm.get('password')?.hasError('complexity') ) {
            <mat-error>Password does not meet complexity requirements</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Checkboxes in a single row -->
      <div class="dialog-field-group dialog-form-grid-full" style="display: flex; flex-direction: row; gap: 24px; align-items: center; margin-top: 5px;">
        <mat-slide-toggle formControlName="changePasswordOnNextLogin">Change Password on Next Login</mat-slide-toggle>
        <mat-slide-toggle formControlName="generateAndEmailPassword">Generate and Email Password</mat-slide-toggle>
        <mat-slide-toggle formControlName="accountLocked">Account Locked</mat-slide-toggle>
        <!-- <mat-checkbox formControlName="changePasswordOnNextLogin">Change Password on Next Login</mat-checkbox>
        <mat-checkbox formControlName="generateAndEmailPassword">Generate and Email Password</mat-checkbox>
        <mat-checkbox formControlName="accountLocked">Account Locked</mat-checkbox> -->
      </div>

      <!-- User Type -->
      <div class="dialog-field-group dialog-form-grid-full" style="margin-top: 16px; margin-bottom: 16px;">
        <mat-label class="mat-form-field-label" style="margin-bottom: 0px;">User Type <span class="req">*</span></mat-label>
        <mat-radio-group formControlName="userType" (change)="onChangeUserType($event.value)" style="margin-top: 0px;">
          <mat-radio-button [value]="1">Office User</mat-radio-button>
          <mat-radio-button [value]="2">Agency User</mat-radio-button>
          <mat-radio-button [value]="3">Multi Office/Agency</mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- Office -->
      <div class="dialog-field-group">
        <mat-label class="mat-form-field-label">Office <span class="req">*</span></mat-label>
        <mat-form-field appearance="outline">
          <mat-select formControlName="office" placeholder="Select an office" [compareWith]="comparatorService.compareById">
            @for( office of offices; track office ) {
              <mat-option [value]="office">
                {{ office | objectdesc}}
              </mat-option>
            }
          </mat-select>
          @if( userForm.get('office')?.hasError('required') ) {
            <mat-error>Office is required</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Agency -->
      <div class="dialog-field-group">
        <mat-label class="mat-form-field-label">Agency <span class="req">*</span></mat-label>
        <mat-form-field appearance="outline">
          <mat-select formControlName="agency" placeholder="Select an agency" [compareWith]="comparatorService.compareById">
            @for( agency of agencies; track agency ) {
              <mat-option [value]="agency">
                {{ agency | objectdesc}}
              </mat-option>
            }
          </mat-select>
          @if( userForm.get('agency')?.hasError('required') ) {
            <mat-error>Agency is required</mat-error>
          }
        </mat-form-field>
      </div>
    }
    @if (activeTab === 1) {
      <!-- Roles Table -->
      <div class="dialog-form-grid-full">
        <div class="roles-table-container">
          <div class="table-wrapper">
            <table mat-table [dataSource]="rolesDataSource" matSort #rolesSort="matSort">

              <!-- Select Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? masterToggleRoles() : null" [checked]="roleSelection.hasValue() && isAllRolesSelected()" [indeterminate]="roleSelection.hasValue() && !isAllRolesSelected()"></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? roleSelection.toggle(row) : null" [checked]="roleSelection.isSelected(row)"></mat-checkbox>
                </td>
              </ng-container>

              <!-- Role Column -->
              <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
                <td mat-cell *matCellDef="let row"> {{row.description}} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="rolesDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: rolesDisplayedColumns;"></tr>
            </table>
          </div>
        </div>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-blue" (click)="onSubmit()" [disabled]="!userForm.valid">
    {{(data.id == -1 ? 'Create' : 'Update')}} User
  </button>
</mat-dialog-actions>
